<div class="absolute inset-0 z-20 bg-black opacity-50"></div>
<div
  class="absolute inset-0 z-30 grid place-items-center"
  *ngIf="notUpdateSuccess; else updatedSuccess">
  <div
    class="h-[100vh] w-full bg-white px-4 md:grid md:h-auto md:w-[800px] md:rounded-3xl md:p-6"
    [ngClass]="{ 'pt-11': isWebview }">
    <div class="mb-6 flex flex-row items-center">
      <button app-icon-button name="x" (click)="closeModal()"></button>
      <h1 class="prose-display-lg ms-3 font-semibold" translate>lbl.additionalDocumentRequest</h1>
    </div>
    <p class="mb-10 text-sm text-neutral-500" *ngIf="additionInfo.additional_file_request">
      {{ additionInfo.additional_file_request.request_remarks }}
    </p>
    <app-unexpected-error
      class="mx-auto mb-10 min-w-[300px] max-w-[500px]"
      *ngIf="unexpectedError$ | async" />
    <div
      class="flex flex-col items-center rounded-lg md:justify-center md:border md:border-dashed md:border-gray-300 md:p-10"
      appDrag
      (files)="filesDropped($event)">
      <input
        type="file"
        accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
        hidden
        id="file"
        (change)="processFile($event)" />
      <label for="file" class="mb-3 w-full text-center">
        <app-icon
          name="upload-cloud"
          class="hidden md:block"
          fontSize="80"
          color="#939694"></app-icon>
        <div class="flex flex-col pb-5 md:hidden">
          <p class="mb-5 text-left text-xl font-medium" translate>remit.uploadMethod</p>
          <div class="flex w-full items-center justify-between">
            <div class="flex items-center">
              <button app-icon-button>
                <app-icon name="upload-cloud" fontSize="20" color="#939694"></app-icon>
              </button>
              <p class="ml-4 text-sm">Upload file</p>
            </div>
            <app-icon name="chevron-right"></app-icon>
          </div>
        </div>
      </label>
      <p class="mb-1 hidden text-sm font-semibold md:block" translate>
        btn.uploadFileFromYourComputer
      </p>
      <p class="hidden text-sm text-neutral-500 md:block" translate>lbl.dropFile</p>
      <div
        *ngIf="uploadError"
        class="my-3 flex w-[343px] items-center gap-3 rounded-xl bg-primary-100 p-3">
        <app-icon name="alert-circle-solid" color="#F00125"></app-icon>
        <div>
          <p class="text-sm font-medium">{{ errorMsg }}</p>
        </div>
      </div>
      <div
        *ngIf="imageFiles.length || otherFiles.length"
        class="mt-5 max-h-[300px] w-full overflow-y-auto">
        <div class="mb-4 grid grid-cols-2 gap-3">
          <div *ngFor="let file of imageFiles; index as i" class="w-full">
            <figure
              *ngIf="file.type.includes('image')"
              class="relative flex aspect-video h-auto w-full items-center justify-center overflow-hidden rounded-xl bg-black">
              <img
                [src]="previewImage(file)"
                alt="Preview Image"
                class="h-full w-auto object-contain" />
              <button
                size="sm"
                class="absolute right-[10px] top-2 flex h-5 w-5 items-center justify-center rounded-full bg-white"
                (click)="removeImageFiles(i)">
                <app-icon name="x" fontSize="14"></app-icon>
              </button>
            </figure>
          </div>
        </div>
        <div
          *ngFor="let file of otherFiles; index as i"
          class="mb-5 flex w-full items-center justify-between rounded-lg border border-neutral-200 p-2">
          <div class="flex items-center">
            <div class="mr-4 flex items-center justify-center rounded-full bg-neutral-100 p-2">
              <app-icon name="file-attachment"></app-icon>
            </div>
            <div>
              <p class="mb-1 text-sm">{{ file.name }}</p>
              <p class="text-xs uppercase text-neutral-500">{{ formatExtention(file) }}</p>
            </div>
          </div>
          <button app-icon-button name="x" size="sm" (click)="removeOtherFiles(i)"></button>
        </div>
      </div>
    </div>
    <div class="mt-6 flex w-full items-center justify-end">
      <button
        app-button
        translate
        [disabled]="files.length === 0"
        (click)="submitFiles()"
        class="absolute bottom-5 right-4 md:static">
        btn.submit
      </button>
    </div>
  </div>
</div>
<ng-template #updatedSuccess>
  <div
    class="fixed left-0 right-0 top-0 z-50 flex w-full items-center justify-center overflow-y-auto overflow-x-hidden md:inset-0">
    <div
      class="fixed bottom-0 flex max-h-full w-full max-w-[420px] items-center justify-center rounded-t-2xl bg-white p-6 shadow md:relative md:rounded-3xl">
      <div class="relative h-full overflow-y-auto">
        <div class="mt-6">
          <p class="prose prose-display-lg mb-3 font-semibold" translate>
            Document upload successful
          </p>
          <button app-button class="w-full" translate (click)="updateSuccesfully()">
            btn.gotIt
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
